
import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const isDashboardPage = location.pathname.startsWith('/dashboard');
  const isSettingsPage = location.pathname.startsWith('/settings');
  const shouldHideFooter = isDashboardPage || isSettingsPage;
  
  return (
    <div className="flex flex-col min-h-screen" style={{ backgroundColor: 'transparent', margin: 0, padding: 0, position: 'relative' }}>
      <Navbar user />
      {/* Main content */}
      <main className="flex-grow" style={{ backgroundColor: 'transparent', margin: 0, padding: 0, position: 'relative' }}>
        {children}
      </main>
      
      {!shouldHideFooter && <Footer />}
    </div>
  );
};

export default Layout;
